<template>
  <ion-list v-show="!hide">
    <ion-item v-if="ENABLE_HELP_VIDEOS && !isLaSalleId" lines="none" button @click.prevent="handleGoToHelp">
      <ion-label>
        {{ messages.USER_MENU.HELP }}
      </ion-label>
      <ion-icon slot="start" :icon="helpCircleOutline" size="large" />
    </ion-item>

    <ion-item lines="none" button style="display: none">
      <ion-label>
        {{ messages.USER_MENU.SILENCE }}
      </ion-label>
      <ion-icon slot="start" :icon="musicalNotesOutline" size="large" />
    </ion-item>
    <ion-item lines="none" button @click.prevent="handleGoToBack">
      <ion-label>
        {{ messages.USER_MENU.GO_TO_BACK }}
      </ion-label>
      <ion-icon slot="start" :icon="arrowUndo" size="large" />
    </ion-item>
    <ion-item lines="none" button @click.prevent="handleGoToSofia">
      <ion-label>
        {{ messages.USER_MENU.GO_TO_SOFIAXT }}
      </ion-label>
      <ion-icon slot="start" :icon="powerOutline" size="large" />
    </ion-item>

    <ion-item lines="none" :style="Boolean(welcome?.studentName) ? '' : 'display:none'">
      <ion-label>
        {{ welcome?.studentName }}
      </ion-label>
      <ion-icon slot="start" :icon="personCircle" size="large" />
    </ion-item>
  </ion-list>
</template>

<script lang="ts">
import { IonList, IonItem, IonLabel, IonIcon } from '@ionic/vue';
import { helpCircleOutline, musicalNotesOutline, powerOutline, personCircle, helpBuoyOutline, arrowUndo } from 'ionicons/icons';
import { defineComponent, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import messages from '@/shared/messages';
import { ENABLE_HELP_VIDEOS } from '@/shared/features';

export default defineComponent({
  components: { IonList, IonItem, IonLabel, IonIcon },
  props: {
    closePopover: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const hide = ref(false);

    const idPhaseQueryParam = route.query?.idPhase
    const idPhaseStr = Array.isArray(idPhaseQueryParam)
    ? idPhaseQueryParam[0] || ''
    : (idPhaseQueryParam || '')

    const isLaSalleId = idPhaseStr.toLowerCase() === '5df6193b-48d2-4bd8-a350-42443c29e0bf'

    const handleCloseUserMenu = () => {
      props.closePopover();
    };

    const handleGoToSofia = () => {
      window.location.href = 'https://www.sofiaxt.com/';
    };

    const handleGoToBack = () => {
      const fallbackUrl = 'https://www.sofiaxt.com/';
      try {
        const identifier = localStorage.getItem('identifier')?.trim();
        const originHost = localStorage.getItem('originHost')?.trim();

        if (!identifier || !originHost || identifier === '.' || identifier === '..') {
          window.location.href = fallbackUrl;
          return;
        }

        const origin = new URL(/^https?:\/\//i.test(originHost) ? originHost : `https://${originHost}`);

        if (
          !['http:', 'https:'].includes(origin.protocol) ||
          !origin.hostname ||
          origin.username ||
          origin.password ||
          origin.pathname !== '/' ||
          origin.search ||
          origin.hash
        ) {
          window.location.href = fallbackUrl;
          return;
        }

        origin.protocol = 'https:';
        origin.pathname = `/Concurso/${encodeURIComponent(identifier)}`;
        origin.searchParams.set('TipoInterfaz', '2');
        window.location.href = origin.href;
      } catch (err) {
        window.location.href = fallbackUrl;
      }
    };

    const welcome = store.getters['welcome/getAllData'];
    const handleGoToHelp = () => {
      if (!ENABLE_HELP_VIDEOS || isLaSalleId) return;
      router.push('/help');
      handleCloseUserMenu();
    };

    const handleOpenTour = () => {
      hide.value = true;
    };
    return {
      helpBuoyOutline,
      helpCircleOutline,
      musicalNotesOutline,
      powerOutline,
      arrowUndo,
      personCircle,
      router,
      handleGoToSofia,
      handleGoToBack,
      handleGoToHelp,
      welcome,
      messages,
      handleOpenTour,
      hide,
      handleCloseUserMenu,
      ENABLE_HELP_VIDEOS,
      isLaSalleId
    };
  }
});
</script>

<style lang="scss" scoped>
ion-icon {
  color: #c5daff;
}

ion-item:hover ion-icon {
  color: var(--IMPERIAL);
}
</style>
